import React, { Component } from 'react';
import styled from 'styled-components';
import { FlexColumn } from 'styles/Layout';
import Routes from 'modules/external_tenant/Routes';
import Header from 'modules/external_tenant/components/HeaderView';
import Footer from 'modules/external_tenant/components/FooterView';
import { media } from 'styles/Mixins';

const Wrapper = styled(FlexColumn)`
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  overflow-x: hidden;
  overflow-y: auto;
`;

const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 360px;
  display: block;
  ${media.sm`
    max-width: 680px;
  `};
  ${media.md`
    max-width: 1024px;
  `};
`;
type PropsType = { history: any };

export default class ExternalTenantContainer extends Component<PropsType> {
  render() {
    return (
      <Wrapper id="Wrapper">
        <Content>
          <Header history={this.props.history} />
          <Routes />
          <Footer />
        </Content>
      </Wrapper>
    );
  }
}
